class YbVideoPlayer extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('video');
    this.button = this.querySelector('[data-yb-video-toggle]');
    if (!this.video || !this.button) return;

    this.button.addEventListener('click', () => this.toggle());
    this.video.addEventListener('play', () => this.update(true));
    this.video.addEventListener('pause', () => this.update(false));
    this.video.addEventListener('ended', () => this.update(false));
    this.update(!this.video.paused);
  }

  async toggle() {
    if (this.video.paused) {
      try {
        await this.video.play();
      } catch (_) {
        this.update(false);
      }
    } else {
      this.video.pause();
    }
  }

  update(isPlaying) {
    this.button.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
    this.button.setAttribute('aria-pressed', String(isPlaying));
    this.button.textContent = isPlaying ? 'Ⅱ' : '▶';
  }
}

if (!customElements.get('yb-video-player')) {
  customElements.define('yb-video-player', YbVideoPlayer);
}

document.querySelectorAll('img[data-yb-fallback]').forEach((image) => {
  image.addEventListener('error', () => {
    const fallback = image.dataset.ybFallback;
    if (!fallback || image.dataset.ybFallbackUsed === 'true') return;
    image.dataset.ybFallbackUsed = 'true';
    image.src = fallback;
  }, { once: true });
});

const hero = document.querySelector('[data-yb-hero]');
if (hero && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  let scheduled = false;
  const updateHero = () => {
    const rect = hero.getBoundingClientRect();
    const progress = Math.max(0, Math.min(1, -rect.top / Math.max(1, rect.height)));
    hero.style.setProperty('--yb-hero-scroll', progress.toFixed(3));
    scheduled = false;
  };
  window.addEventListener('scroll', () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(updateHero);
  }, { passive: true });
  updateHero();
}
